import script from "./FullSizeImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./FullSizeImage.vue?vue&type=script&setup=true&lang=ts"

import "./FullSizeImage.vue?vue&type=style&index=0&id=08dda507&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08dda507"]])

export default __exports__